import SimpleHeader from '../../components/layout/SimpleHeader';
import { Select, Table, TableColumnsType } from 'antd';
import Button from '../../components/Button';
import useNotification from '../../hooks/useNotification';
import useAxios from '../../hooks/useAxios';
import {
  IGetPtItems,
  IGetTestTypes,
  IPtItem,
  ITestType,
} from '../../models/testCenter.model';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPtItems, getTestTypes } from '../../api/testCenter.api';
import _ from 'lodash';
import styled from 'styled-components';
import useAuth from '../../hooks/useAuth';
import Split from 'react-split';

const Block = styled.div`
  .table-custom {
    margin-top: 20px;
  }
`;

const CbtPt = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetTestTypes>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetPtItems>();

  const [prts, setPrts] = useState<ITestType[]>([]);
  const [pts, setPts] = useState<ITestType[]>([]);
  const [prtCode, setPrtCode] = useState<number | undefined>();
  const [data, setData] = useState<IPtItem[]>([]);

  useEffect(() => {
    execute(getTestTypes());
  }, []);

  useEffect(() => {
    if (res && !isLoading) {
      const _data: ITestType[] = _.cloneDeep(res.data);
      const _prts = _data.filter((item) => item.examDiv === 'PR');
      setPrts(_prts);
      const _pts = _data.filter((item) => item.examDiv === 'PT');
      setPts(_pts);
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      let _data: IPtItem[] = _.cloneDeep(res2.data);
      _data.forEach((item) => {
        item.status = 'update';
      });
      setData(_data);
    }
  }, [res2, isLoading2]);

  const onSelectPrt = (prtCode: number | undefined) => {
    if (!prtCode) return;
    setPrtCode(prtCode);
    execute2(getPtItems(prtCode));
  };

  const onSetData = (index: number, key: string, value: string) => {
    const _data: any = [...data];
    _data[index][key] = value;
    setData(_data);
  };

  const onSubmit = () => {
    if (!prtCode) return;
    if (!data.length) {
      return infoNotification(t('cbt.placeTest.message1'));
    }

    let prevEndScore: number | null = null;
    for (let i = 0; i < data.length; i++) {
      if (
        data[i].srtScore === null ||
        data[i].endScore === null ||
        data[i].srtScore === '' ||
        data[i].endScore === '' ||
        !data[i].targetExamTypeCode
      ) {
        return infoNotification(t('cbt.class.message1'));
      }
      if (prevEndScore && !(Number(data[i].srtScore) === prevEndScore + 1)) {
        return infoNotification(t('cbt.class.message2'));
      }
      if (i === 0) {
        if (Number(data[i].srtScore) !== 0) {
          return infoNotification(t('cbt.class.message2'));
        }
      }
      if (Number(data[i].srtScore) <= Number(data[i].endScore)) {
        return infoNotification(t('cbt.class.message2'));
      }
      prevEndScore = Number(data[i].endScore);
    }
  };

  const onAddRow = () => {
    if (!prtCode) {
      return infoNotification(t('cbt.placeTest.message2'));
    }

    const _data: IPtItem[] = [...data];
    _data.push({
      status: 'create',
      srtScore: null,
      endScore: null,
      targetExamTypeCode: null,
    });
    setData(_data);
  };

  const columns: TableColumnsType<any> = [
    {
      title: t('cbt.placeTest.column1'),
      dataIndex: 'platLevelCode',
      key: 'platLevelCode',
      align: 'center',
      render: (value, record, index) => (
        <div className="flex flex-justify-center">
          <div className="w-100p">
            <input
              type="text"
              className="form-control"
              value={record.srtScore}
              onChange={(e) => onSetData(index, 'srtScore', e.target.value)}
            />
          </div>
          <span className="v-line">&nbsp;~&nbsp;</span>
          <div className="w-100p">
            <input
              type="text"
              className="form-control"
              value={record.endScore}
              onChange={(e) => onSetData(index, 'endScore', e.target.value)}
            />
          </div>
        </div>
      ),
    },
    {
      title: 'Placement Test',
      key: 'targetExamTypeCode',
      dataIndex: 'targetExamTypeCode',
      align: 'center',
      render: (value, record, index) => (
        <div className="w-100">
          <Select
            className="w-100"
            placeholder={t('common.button.select')}
            value={record.targetExamTypeCode}
            onChange={(value) => onSetData(index, 'targetExamTypeCode', value)}
          >
            {pts?.map((item: any) => {
              return (
                <Select.Option value={item.examTypeCode}>
                  {item.examTypeName}
                </Select.Option>
              );
            })}
          </Select>
        </div>
      ),
    },
  ];

  return (
    <>	
    <Block className="content">
      {isLoading || isLoading2 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <SimpleHeader
        iconFile="icon-cbt-big.svg"
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.placeTest.title1')}
        onlyTitle={true}
      />

      <Split
        className="splite-divide"
        sizes={[37, 63]}
        minSize={100}
        expandToMin={false}
        gutterSize={10}
        gutterAlign="center"
        snapOffset={30}
        dragInterval={1}
        direction="horizontal"
        cursor="col-resize"
      >
        <div className="col-frame left_panel">
          <div className='comm-bx__between'>
          </div>
          <div className='comm-table__area'>
            <table>
              <thead>
                <tr>
                  <th>Pre Test</th>
                </tr>
              </thead>
              <tbody>
                {prts?.map((item: ITestType) => (
                  <tr
                    key={item.examTypeCode}
                    className={
                      prtCode === item.examTypeCode ? 'chosen' : 'pointer'
                    }
                    onClick={() => onSelectPrt(item.examTypeCode)}
                  >
                    <td>{item.examTypeName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="col-frame right_panel">
          <div className='comm-bx__between'>
            <div></div>
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink-line"
                onClick={onAddRow}
                text={t('cbt.class.button1')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
          <div className='comm-table__area'>
            <Table
              columns={columns}
              dataSource={data || undefined}
              pagination={{
                pageSize: 99999,
              }}
            />
            <div className='comm-bx__space'>
              <div className="comm-btn__area right">
                <Button
                  className="btn-basic pink"
                  onClick={onSubmit}
                  text={t('common.button.save')}
                  writeAuthYn={writeAuthYn}
                  disabled={process.env.REACT_APP_IS_DEV !== 'Y'}
                />
                <Button
                  className="btn-basic pink-line"
                  onClick={onAddRow}
                  text={t('cbt.class.button1')}
                  writeAuthYn={writeAuthYn}
                />
              </div>
            </div>
          </div>
        </div>
      </Split>
    </Block>
    </>
  );
};

export default CbtPt;
